import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { ContenusService } from 'src/app/services/contenus.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.css'],
  providers : [MessageService]
})
export class PhotosComponent implements OnInit {
  
  validName: string;
  duplicateName: string;
  cqName: string;
  douteName: string;

  backgroundColor : string = '#ffffff';

  motifs: Object[] = [];
  motifsCq : Object[] = [];

  errors : SelectItem[] = [];
  ContenusAnterieurs : Object[] = [];
  selectedErrors : Object[] = [];
  
  @Input('id-moderation') idModeration : string;
  @Input('numero-contenu') numContenu : string;
  @Input('id-contenu') idContenu : number;
  @Input('lien') lien : string;
  @Input('is-logo') isLogo : boolean; 
  @Input('cq') cq : boolean = false;
  @Input('valide') valid: boolean = false;
  @Input('duplicate') duplicate: boolean = false ;
  @Input('read-only') readonly: boolean = false;
  @Input('no-duplicate') noDuplicate : boolean = false;
  @Input('valide-cq') validationCQ: boolean = null;
  @Input("erreurs-cq") inputErreursCq : Object[] = [];
  @Input('erreurs') inputErreurs : Object[] = [];
  @Input('site-web') site : string;
  @Input('doute') isDoute : boolean = false;
  @Input('attente-doute') attenteDoute : boolean = false;
  @Input('is-retour') isRetour : boolean = false;


  @Output() validChangedEvent = new EventEmitter<Object>();
  @Output() erreursChangedEvent = new EventEmitter<Object>();
  @Output() validCqChangedEvent = new EventEmitter<Object>();
  @Output() erreursCqChangedEvent = new EventEmitter<Object>();
  @Output() douteEvent = new EventEmitter<Object>();

  constructor(private contenuService : ContenusService, private msgService : MessageService) { }



  ngOnInit(): void {
    let typeTraitement = (this.cq === true) ? 1 : 0;
    if(this.isLogo) {
      this.contenuService.recupererListeMotifs(3, typeTraitement).subscribe(results => {
        if(results["status"] !== "success"){
          console.log("Une erreur dans la requête:" + results["cause"]);
        }else {
          let input = results["data"];
          this.initErrors(input);
        }

        if(this.inputErreurs !== null && this.inputErreurs !== undefined) this.motifs = this.inputErreurs;
        if(this.inputErreursCq !== null && this.inputErreursCq !== undefined) this.motifsCq = this.inputErreursCq;
        this.selectedErrors = this.motifs;
      });
    }else {
      this.contenuService.recupererListeMotifs(1, typeTraitement).subscribe(results => {
        if(results["status"] !== "success"){
          console.log("Une erreur dans la requête:" + results["cause"]);
        }else {
          let input = results["data"];
          this.initErrors(input);
        }

        if(this.inputErreurs !== null && this.inputErreurs !== undefined) this.motifs = this.inputErreurs;
        if(this.inputErreursCq !== null && this.inputErreursCq !== undefined) this.motifsCq = this.inputErreursCq;
        
        this.selectedErrors = this.motifs;
      });
    }


    let optionsForEtatsAnterieurs = {
      idModeration : this.idModeration,
      numContenu : this.numContenu
    }


    this.contenuService.recupererEtatsAnterieurs(optionsForEtatsAnterieurs).subscribe(results => {
      if(results["status"] !== "success"){
        console.log("Une erreur dans la requête:" + results["cause"]);
      }else {
        let listeContenus = results["data"];

        listeContenus.forEach(current => {
          this.ContenusAnterieurs.push(current);
        });
      }
    });

    

    this.validName = this.generateRandomString();
    this.duplicateName = this.generateRandomString();
    this.cqName = this.generateRandomString();
    this.douteName = this.generateRandomString();
  }

  /**
   * 
   * @param input 
   * met les erreurs entrées en input pour les mettre dans la liste
   */
  initErrors(input) {
    input.forEach(current => {
      let motif = {
        label : current["designation_motif"],
        value : current
      };
      this.errors.push(motif);
    });
  }


  /**
   * Rajoute des erreurs pré-selectionnées dans le multiselect erreur
   */
  initCurrentErrors(input) {
    let sortie = [];

    input.forEach(current => {
      let motif = {
        label : current["designation_motif"],
        value : current
      };
      sortie.push(motif);
    });
    
    return sortie;
  }

  generateRandomString (length=6){
    return Math.random().toString(20).substr(2, length)
  }

  /**
   * @param valid
   * Emet la valeur de OK ou KO du contenu à chaque changement
   */
  validChanged(valid: boolean) {
    let sortie = {
      id_contenu : this.idContenu,
      is_valid: valid
    }
    if(valid) {
      this.motifs = [];
      this.setErrors(this.motifs);
    }
    this.validChangedEvent.emit(sortie);
  }

  validCqChanged(valid : boolean) {
    let sortie = {
      id_contenu : this.idContenu,
      is_valid : valid
    }
    if(valid) {
      this.motifsCq = [];
      this.setCqErrors(this.motifsCq);
    }
    this.validCqChangedEvent.emit(sortie);
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs à chaque changement
   */
  setErrors(errors: Object[]) {
    let sortie = {
      id_contenu : this.idContenu,
      erreurs : errors
    }
    this.motifs = errors;
    this.erreursChangedEvent.emit(sortie);
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs de cq à chaque changement
   */
  setCqErrors(errors: Object[]) {
    let sortie = {
      id_contenu : this.idContenu,
      erreurs : errors
    }

    this.motifsCq = errors;
    this.erreursCqChangedEvent.emit(sortie);
  }

  /**
   * 
   * @param duplicated 
   * Vérifie si un contenu est dupliqué ou non et change la valeur de 
   */
  duplicateChanged(duplicated: boolean) {
    if(duplicated === true) {
      this.motifs = [
        {
          id_motif : "4",
          designation_motif : "Duplicate content / Non-respect droit d’auteur / utilisation d'image libre de droit",
          code_rejet : "MP004"
        }
      ];
      this.valid = false;
      this.validChanged(false);
    }else {
      this.motifs = [];
    }

    let sortie = {
      id_contenu : this.idContenu,
      erreurs : this.motifs
    }

    this.erreursChangedEvent.emit(sortie);
  }




  /**
   * Permet d'ouvrir le lien dans un nouvel onglet
   */
  openLinkOnNewTab(link = this.site ){
    if (!link.match(/^https?:\/\//i)) {
        link = 'http://' + link;
    }
    var url = encodeURI(link);
    window.open(url, "_blank");
  }


  linkCopied(lien: string) {
    

    this.msgService.add({
      severity:'info',
      summary:'Lien mise dans le clipboard',
      detail: lien
    })
  }


  redirectToGoogle(lien : string) {
    let blob = this.dataURItoBlob(lien);
    let objectUrl = URL.createObjectURL(blob);
    lien = encodeURIComponent(lien);
    lien = "https://www.google.com/searchbyimage?&image_url=" + lien;
    
    var url = encodeURI(lien);
    window.open(url, "_blank");
  }


  dataURItoBlob(dataURI)
{
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;

    if(dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for(var i = 0; i < byteString.length; i++)
    {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type: mimeString});
}

  
  /**
   * Fonction qui envoie les données du contenu en cas de doute
   */
  doute(doute: boolean) {
    if(doute) {
      this.valid = null;
      this.validChanged(null);
      this.duplicate = false;
      this.setErrors([]);
    }

    let type = (this.isLogo) ? 'logo' : 'photo';

    let options = {
      doute : doute,
      numContenu : this.numContenu,
      type  : type
    };

    this.douteEvent.emit(options);
  }


  disableModeration() { //valeur de disabled 
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.isDoute || this.cq) {
      return true;
    }

    return false;
  }


  disableDoute() {
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.cq) {
      return true;
    }
  }


}
